import { observable, makeObservable } from 'mobx';
import { createModelSchema, primitive } from 'serializr';
import { optional } from '@vromo/models';

export enum Currency {
    AUD = 'aud',
    EUR = 'eur',
    USD = 'usd'
}

export class JobPayable {
    currency?: string;
    order: number | null = null;
    delivery: number | null = null;
    tip: number | null = null;
    cash: number | null = null;

    constructor() {
        makeObservable(this, {
            currency: observable,
            order: observable,
            delivery: observable,
            tip: observable,
            cash: observable
        });
    }

    /** updates payable number value avoiding any decimals and converting the given value to cents
     * @param value should be in euros, pounds...
     */
    setValue(field: "order" | "delivery" | "tip" | "cash", value: number): JobPayable {
        // avoid any decimals in value
        this[field] = Math.round(value * 100)
        return this
    }

    /** limit the number of decimals, maximum of 9999999.99*/
    static formatValue(value = "0"): string {
        const values = value
            .trim()
            .replace(",", ".").split(".", 2)

        const limitedValue = Number(values[0]) < 9999999 ? Number(values[0]) : 9999999
        const formattedValue = [
            Math.abs(limitedValue).toString(),
            ...values[1] ? [values[1]?.slice(0, 2)] : []
        ].join(".")
        return formattedValue
    }
}

createModelSchema(JobPayable, {
    currency: primitive(),
    order: optional(primitive()),
    delivery: optional(primitive()),
    tip: optional(primitive()),
    cash: optional(primitive())
});
